/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

// Browser polyfills
import 'regenerator-runtime/runtime.js'

// Setup environment before anything else
import Environment from '../js/utilities/Environment'
Environment.current.setup()

import IdentitySDK from '../js/utilities/IdentitySDK'
import LandingPage from './LandingPage'

// Determine if we are on the root path
const paths = window.location.pathname.split('/').filter(p => !!p)
const isOnRoot = !paths || paths.length < 1
const isLocalhost = window.location.href.includes('localhost')

if (isOnRoot && !isLocalhost) {

    // Redirect to Studio if we are on the root domain
    const domain = window.location.href.includes('.cool') ? 'studio.vatominc.cool' : window.location.href.includes('.cc') ? 'studio.vatominc.cc' : 'studio.vatom.com'
    window.open(`https://${domain}`, '_self')

} else if (paths[0] === 'logout' || paths[0] === 'logout-callback') {

    // Find space the user was in before logout, or just go to home page
    const domain = isLocalhost ? 'spaces.vatom.com' : (window.location.href.includes('.cool') ? 'spaces.vatominc.cool' : window.location.href.includes('.cc') ? 'spaces.vatominc.cc' : 'spaces.vatom.com')
    const space = localStorage.getItem('logout-from-space') || null
    const url = space && space.length > 0 ? `https://${domain}/@${space}` : `https://${domain}`

    // Remove reference to previous space
    localStorage.removeItem('logout-from-space')

    // Trigger callbacks and redirect
    IdentitySDK.onCallbacks().then(() => window.open(url, '_self'))

} else {

    // Show landing page
    LandingPage.show()

    // Register the service worker
    window.navigator.serviceWorker?.register('./service-worker.js', {
        type: 'classic',
        updateViaCache: 'none',
        scope: window.location.origin + window.location.pathname     // <-- Only for this exact html file
    })

}
